module.exports = __webpack_public_path__ + "img/miljo-6.bb51712d.png";